import React, { Component } from "react";
import { Table, Card, Row, Button, Image, Col } from "react-bootstrap";
import AddBank from "./AddBank";
import EditBank from "./EditBank";
import ViewBank from "./ViewBank";

import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");
class Bank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddModel: false,
      showEditModel: false,
      BankViewShow: false,
      searchShow: false,
      searchBank: "",
      page: 0,
      perPage: 10,
      Spage: 0,
      perPageS: 10,
      filterValue: "All",
      FilterTable: false
    };
  }
  componentDidMount() {
    this.props.fetchBanks();
  }

  handleAddBank = () => {
    this.setState({
      showAddModel: true,
    });
  };
  closeAddModel = () => {
    this.setState({
      showAddModel: false,
    });
  };

  handlePageSearchClick = e => {
    const selectedSearchPage = e.selected;
    this.setState({ Spage: selectedSearchPage });

    this.props.stateSearch({
      searchBank: this.state.searchBank,
      Spage: selectedSearchPage + 1
    });
  };

  SearchOnChange = event => {
    let bank = event.target.value;

    this.setState({
      searchShow: true,
      searchBank: bank,
      FilterTable: false,
      filterValue: "All"
    });
    this.props.bankSearch({
      searchBank: bank,
      Spage: this.state.Spage + 1
    });
  };

  handleEditBank = (item) => {
    this.setState({
      showEditModel: true,
      ItemList: item,
    });
  };

  closeEditModel = () => {
    this.setState({ showEditModel: false });
  };


  handleBankView = (item) => {
    this.setState({
      BankViewShow: true,
      bankViewDtls: item,
    });
  };

  handleClosebank = () => {
    this.setState({ BankViewShow: false });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.bankSlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };

  render() {
    let p = this.state.page + 1;
    const count = this.props.BankCount && this.props.BankCount;
    let bankPageCount = Math.ceil(count / this.state.perPage);

    let p2 = this.state.Spage + 1;
    const SearchCount =
      this.props.bankSearchCount && this.props.bankSearchCount;
    const SearchPageCount = Math.ceil(SearchCount / this.state.perPageS);
    return (
      <div>
        <Card>
          <Card.Header>
               <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col
                xs={12}
                sm={12}
                md={3}
                lg={3}
              >
                <h3>Bank</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <div className="userInput">
                    <i className="fa fa-search fa-lg userIcon"></i>
                    <input
                      type="text"
                      placeholder="Search by Bank name"
                      onChange={this.SearchOnChange}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="countryRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {count === undefined && SearchCount === undefined ? (
                      0
                    ) : (
                      <span>
                        {!this.state.searchShow && count}
                        {this.state.searchShow && SearchCount}
                      </span>
                    )}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Button
                style={{ marginBottom: "15px" }}
                onClick={() => this.handleAddBank()}
              >
                <i className="fa fa-plus fa-md"></i>
                <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                  ADD
                </span>
              </Button>
              <AddBank
                showAddModel={this.state.showAddModel}
                closeAddModel={this.closeAddModel}
                AddBank={this.props.AddBank}
                resetPage={this.resetPage}
              />
            </div>
            {!this.state.searchShow && !this.state.FilterTable && (
              <div>
                <Table responsive className="cmnMainTable" bordered striped>
                  <thead>
                    <tr className="cmnMainTableHd">
                      <th style={{ width: "7%" }}>SL NO</th>
                      <th style={{ width: "20%" }}>Bank Name</th>
                      <th style={{ width: "20%" }}>Bank Code</th>
                      <th>Description</th>
                      <th>Active</th>
                      <th>Created Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.BankList &&
                      this.props.BankList.map((item, i) => (
                        <tr key={i}>
                          <td>{10 * (p - 1) + i + 1}</td>
                          <td className="cmn_Cap">
                            {item !== null && item.name}
                          </td>
                          <td>
                            {item !== null && item.code}
                          </td>
                          <td>
                            {item !== null && item.desc}
                          </td>
                          <td>{item !== null && item.isActive ? "Yes" : "No"}</td>
                          <td className="cmn_Cap">
                            {item.createdAt !== null &&
                              dateFormat(item.createdAt, "mediumDate")}
                          </td>
                          <td className="cmnViewIcon">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.handleBankView({
                                    item: item,
                                  })
                                }
                              ></i>
                              <ViewBank
                                show={this.state.BankViewShow}
                                handleClose={this.handleClosebank}
                                bankViewDtls={this.state.bankViewDtls}
                                resetPage={this.resetPage}
                              />

                              <i
                                className="fa fa-edit fa-lg "
                                style={{
                                  paddingLeft: 10,
                                }}
                                onClick={() => this.handleEditBank(item)}
                              ></i>
                              <EditBank
                                showEditModel={this.state.showEditModel}
                                closeEditModel={this.closeEditModel}
                                ItemList={this.state.ItemList}
                                EditBank={this.props.EditBank}
                                resetPage={this.resetPage}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            )}
            {/* ------------------------search---------------------- */}
            {this.state.searchShow && !this.state.FilterTable && (
              <div className="StateMainTable">
                <Table
                  responsive
                  striped
                  className="cmnMainTable"
                  bordered
                >
                  <thead>
                    <tr className="cmnMainTableHd">
                      <th style={{ width: "7%" }}>SL NO</th>
                      <th style={{ width: "20%" }}>Bank Name</th>
                      <th style={{ width: "20%" }}>Bank Code</th>
                      <th>Description</th>
                      <th>Active</th>
                      <th>Created Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.bankSearchList &&
                      this.props.bankSearchList.map((item, i) => (
                        <tr key={i}>
                          <td>{10 * (p2 - 1) + i + 1}</td>
                          <td className="cmn_Cap">
                            {item !== null && item.name}
                          </td>
                          <td>
                            {item !== null && item.code}
                          </td>
                          <td>
                            {item !== null && item.desc}
                          </td>
                          <td>{item !== null && item.isActive ? "Yes" : "No"}</td>
                          <td className="cmn_Cap">
                            {item.createdAt !== null &&
                              dateFormat(item.createdAt, "mediumDate")}
                          </td>
                          <td className="cmnViewIcon">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.handleBankView({
                                    item: item,
                                  })
                                }
                              ></i>
                              <ViewBank
                                show={this.state.BankViewShow}
                                handleClose={this.handleClosebank}
                                bankViewDtls={this.state.bankViewDtls}
                                resetPage={this.resetPage}
                              />

                              <i
                                className="fa fa-edit fa-lg "
                                style={{
                                  paddingLeft: 10,
                                }}
                                onClick={() => this.handleEditBank(item)}
                              ></i>
                              <EditBank
                                showEditModel={this.state.showEditModel}
                                closeEditModel={this.closeEditModel}
                                ItemList={this.state.ItemList}
                                EditBank={this.props.EditBank}
                                resetPage={this.resetPage}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            )}

            {!this.state.searchShow &&
              (this.props.BankList === undefined ||
                (this.props.BankList &&
                  this.props.BankList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Banks Found</div>
                </div>
              )}
            {this.state.searchShow &&
              (this.props.bankSearchList === undefined ||
                (this.props.bankSearchList &&
                  this.props.bankSearchList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Banks Found</div>
                </div>
              )}
          </Card.Body>
          {!this.state.searchShow &&
            bankPageCount &&
            bankPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={bankPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
          {this.state.searchShow &&
            SearchPageCount &&
            SearchPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.Spage}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={SearchPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageSearchClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default Bank;
